import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-16 grain relative" data-testid="admin-login-page">
      <div className="w-full max-w-md brut-card p-8 lg:p-10 relative">
        <div className="overline">/// Admin Console</div>
        <h1 className="font-display font-black uppercase tracking-tighter text-4xl mt-4 text-white">Sign in.</h1>
        <p className="text-[#8C939D] text-sm mt-2">Manage business info, gallery & inquiries.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="overline text-[#8C939D] block mb-2">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-brut"
              data-testid="admin-login-email-input"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="overline text-[#8C939D] block mb-2">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-brut"
              data-testid="admin-login-password-input"
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div className="border border-[#DC2626] text-[#FCA5A5] p-3 text-sm" data-testid="admin-login-error">
              {error}
            </div>
          )}

          <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60" data-testid="admin-login-submit-btn">
            {loading ? "Authenticating…" : <><Lock size={16} /> Sign in <ArrowRight size={16} /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
